import { useToast } from "hooks";
import { useCallback, useRef, useState } from "react";
import { post } from "utils/DeApi";
import { getURLFileExtension } from "utils/StringUtils";

const useEmbeddAllFiles = ({ audit, isAccess }) => {
  const toast = useToast();
  const subscribedPromises = useRef([]);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const rejectPromise = (msg) => {
    toast.info("Info", msg);
    setIsLoading(false);
    return Promise.resolve({ data: [] });
  };

  const embeddAllFiles = useCallback(
    (files) => {
      if (!isAccess) return;
      setError(null);
      setIsLoading(true);

      const allQuestionLevelFiles = files.every(
        ({ observationId }) => !!observationId,
      );

      const allProcessedFiles = files.every(
        ({ mlProcessStatus }) => mlProcessStatus === true,
      );

      const isQuestionLevelAndProcessedFiles = files.every(
        ({ observationId, mlProcessStatus }) =>
          !!observationId || mlProcessStatus === true,
      );
      const fileIds = files
        .filter(({ observationId, mlProcessStatus, url }) => {
          const isMlProcess = [false, null, "process"].includes(
            mlProcessStatus,
          );
          const fileURL = url || "";
          const fileEXT = getURLFileExtension(fileURL);
          const isFormat = ["pdf", "docx", "doc"].includes(fileEXT);
          return !observationId && isMlProcess && isFormat;
        })
        .map(({ fileId }) => fileId);

      if (allProcessedFiles) {
        return rejectPromise("Files are already processed.");
      }
      if (allQuestionLevelFiles) {
        return rejectPromise(
          "Question Level Files cannot be included in the AI Process.",
        );
      }
      if (isQuestionLevelAndProcessedFiles) {
        return rejectPromise(
          "Please Select Files that are not processed or not Question Level Files.",
        );
      }
      if (!fileIds.length) return rejectPromise("No Files to AI Process.");

      const embeddAllFilesPromise = post(
        `ml/audits/${audit?.auditId}/multiple-file-uploads`,
        {
          fileMetaIds: fileIds,
        },
      );

      embeddAllFilesPromise.promise
        .then((response) => {
          toast.success(
            "Success",
            "The files have been sent for AI processing.",
          );
          return response;
        })
        .catch((error) => !error.isCanceled && setError(error))
        .finally(() => setIsLoading(false));

      subscribedPromises.current.push(embeddAllFilesPromise);
      return embeddAllFilesPromise.promise;
    },
    [audit?.auditId, isAccess, toast],
  );

  return {
    error,
    isLoading,
    embeddAllFiles,
  };
};

export default useEmbeddAllFiles;
